import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addIssueType: {
		id: 'config-in-context-issue-types.type-select-with-add-issue-type-modal.add-issue-type',
		defaultMessage: 'Add issue type',
		description:
			'Dropdown menu item. Clicking this will open a modal where they can add or create new issue types.',
	},
});
